import {useParams} from "react-router-dom";
import NotFoundPage from "../NotFoundPage";
import {CATEGORIES} from "../../utils/constants";
import {NewApplicationStep3Feature} from "../../features/newApplicationStep3";

const NewApplicationStep3Page = () => {
  const {category} = useParams();

  if (CATEGORIES.map(c => c.path).includes(category)) {
    return <NewApplicationStep3Feature />
  }
  return <NotFoundPage />
}

export default NewApplicationStep3Page;